export default __webpack_public_path__ + "static/media/marking.47b15307.png";